import React, { Component } from 'react'
import * as utils from "../utils";
import RsvpToPerformActionLink from "../common/components/rsvp-to-perform-action-link";
import { Link } from 'react-router';
import urls from 'urls';
import ToolTip from '~/common/components/Tooltip/index'

const EventSettings = React.createClass({
  getInitialState: function() {
    const rsvp = window.evite_event.rsvp;
    return {
      formSubmitting: false,
      formSuccess: false,
      formError: false,
      email_new_comments: rsvp && rsvp.notifications ? rsvp.notifications.email_new_comments : true,
      email_new_rsvp: rsvp && rsvp.notifications ? rsvp.notifications.email_new_rsvp : false,
      notify_only_my_activity: rsvp && rsvp.notifications ? rsvp.notifications.notify_only_my_activity : false,
      notifyOnlyMyActivityDisabled: rsvp && rsvp.notifications ? rsvp.notifications.email_new_comments : true
    }
  },

  render: function() {
    const hasRsvpd = utils.hasRsvpd();
    const isDisabled = !hasRsvpd || this.state.formSubmitting;
    const feedDisabled = window.evite_event.options.event_option_disable_feed;
    const notifyOnlyMyActivityDisabled = this.state.email_new_comments;
    return (
      <div>
        { !hasRsvpd && !feedDisabled &&
          <RsvpToPerformActionLink action="change settings" />
        }
        <div className="simple-shadowbox event-settings">
          <h2>Event Settings</h2>
          { feedDisabled &&
            <div className="form-notification">
              Note: Settings are disabled because you are not attending.<br/>
              <Link to={utils.eventTabUrlPath("rsvp")}>Change your RSVP.</Link>
            </div>
          }
          <form onSubmit={this.handleSubmit}>
            { feedDisabled && !utils.isHost() &&
              <div className="form-notification">
                The host has disabled notifications for this event
              </div>
            }
            { !feedDisabled &&
              <fieldset>
                <input
                  type="checkbox"
                  id="notify-only-my-activity"
                  name="something_else"
                  checked={this.state.notify_only_my_activity || this.state.email_new_comments}
                  onChange={this.handleEventNotifyOnlyMyActivityChanged}
                  disabled={notifyOnlyMyActivityDisabled}
                      />
                      <label htmlFor="notify-only-my-activity">
                    <span></span>
                    Notify me of activity that involves me
                    { !utils.isMobile() && <ToolTip text="You will be notified when a guest replies to you, likes your post, mentions or tags you."/>}
                </label>
               </fieldset>
            }
            { !feedDisabled &&
              <fieldset>
                <input
                  type="checkbox"
                  id="notify-event-activity"
                  name="something"
                  checked={this.state.email_new_comments}
                  onChange={this.handleEventActivityChanged}
                  disabled={isDisabled}
                />
                <label htmlFor="notify-event-activity">
                  <span></span>
                  Notify me of event activity (photos, comments, and more)
                  { !utils.isMobile() && <ToolTip text="When guests comment, or upload photos."/>}
                </label>
              </fieldset>
            }
            { (utils.isHost() || !window.evite_event.options.event_option_private_guestlist) &&
              <fieldset>
                <input
                  type="checkbox"
                  id="notify-guest-rsvp"
                  name="something"
                  checked={this.state.email_new_rsvp}
                  onChange={this.handleGuestsRsvpChanged}
                  disabled={isDisabled}
                />
                <label htmlFor="notify-guest-rsvp">
                  <span></span>
                  Notify me when guests RSVP
                </label>
              </fieldset>
            }
            { (utils.isHost() || !feedDisabled) &&
              <button
                className="button-primary small-32"
                disabled={isDisabled}
              >
                Save
              </button>
            }
            { this.state.formSuccess &&
              <span className="form-success">
                Settings saved!
              </span>
            }
            { this.state.formError &&
              <span className="form-error">
                Error - please try again.
              </span>
            }
          </form>
        </div>
      </div>
    )
  },
  handleGuestsRsvpChanged: function() {
    this.setState({
      email_new_rsvp: !this.state.email_new_rsvp,
      formSuccess: false,
      formError: false
    })
  },
  handleEventActivityChanged: function() {
    this.setState({
      email_new_comments: !this.state.email_new_comments,
      notifyOnlyMyActivityDisabled: this.state.email_new_comments,
      notify_only_my_activity: this.state.notify_only_my_activity || this.state.email_new_comments,
      formSuccess: false,
      formError: false
    })
  },
  handleEventNotifyOnlyMyActivityChanged: function() {
    this.setState({
      notify_only_my_activity: !this.state.notify_only_my_activity,
      formSuccess: false,
      formError: false
    })
  },
  handleSubmit: function(e) {
    e.preventDefault();
    const url = urls.get('ajax_event_settings', {
      event_id: window.evite_event.id
    });
    let formData = {
      email_new_comments: this.state.email_new_comments,
      email_new_rsvp: this.state.email_new_rsvp,
      notify_only_my_activity: this.state.notify_only_my_activity,
      guest_id: window.guest_id
    }
    this.setState({
      formSubmitting: false,
      formSuccess: false,
      formError: false
    });
    window.$.post(url, formData, (response) => {
      this.setState({
        formSuccess: true
      });
      window.evite_event.rsvp.notifications.email_new_comments = formData.email_new_comments;
      window.evite_event.rsvp.notifications.email_new_rsvp = formData.email_new_rsvp;
      window.evite_event.rsvp.notifications.notify_only_my_activity = formData.notify_only_my_activity;
    })
    .fail((xhr, status, data) => {
      this.setState({
        formError: true
      });
    })
    .always(() => {
      this.setState({
        formSubmitting: false
      })
    })
  }
});

export default EventSettings;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/event-settings/components.es6